/* eslint-disable no-plusplus */
import React, { useEffect, useState } from "react";
import { MenuItem } from "@mui/material";
import { IoDocumentAttach } from "react-icons/io5";
import { useFiltrarViasPV } from "services/api/AppWeb_PropostaVendas/filtrar-vias-vp";
/* eslint-disable import/order */
/* eslint import/no-duplicates: "off" */
import { format } from "date-fns";
import { ptBR } from "date-fns/locale";
import MaterialUI from "../../../../../../../material-UI";

import * as Styles from "./styles";
import { useVincularOportunidade } from "services/api/AppWeb_PropostaVendas/vincular-oportunidade";
import CustomInput from "components/dialogCommon/templates/newOportunityForm/components/CustomInput";
import { useValidarCotacao } from "services/api";

interface Props {
  onClose: () => void;
  headerData?: any;
  unidadeDataReal?: any;
  numeroCotacao?: string;
  idLead: string | undefined;
  refetch: () => void;
}

interface DocumentProps {
  tipoExtensao: string;
  base64: string;
  nome: string;
}

const dataViasPV = [
  { label: "1ª via com comissão", value: 1 },
  { label: "1ª via sem comissão", value: 2 },
  { label: "2ª via menor", value: 3 },
  { label: "3ª via cliente", value: 4 },
  { label: "4ª via cliente simplificada", value: 5 },
  // { label: "5ª via Wacc", value: 6 },
  // { label: "6ª via CDI", value: 7 },
];

const Footer: React.FC<Props> = (props) => {
  const [dataVias, setDataVias] = useState<any>(null);
  const [dataViasList, setDataViasList] = useState<any[]>([]);
  const [numeroCotacao, setNumeroCotacao] = useState<string>(
    props?.numeroCotacao ? props?.numeroCotacao : ""
  );
  const [documento, setDocumento] = useState<DocumentProps | null>(null);

  const { refetch: cotacaoRefetch, status: cotacaoStatus } = useValidarCotacao({
    IdCotacao: numeroCotacao,
    queryKey: "validar-cotacao-nova-oportunidade",
  });
  const [salvarDisabled, setSalvarDisabled] = React.useState<boolean>(true);

  const {
    mutate: mutateVincular,
    isSuccess: isSuccessVincular,
    isLoading,
  } = useVincularOportunidade({
    idLead: props?.idLead,
    numeroCotacao,
    anexo: null,
  });

  useEffect(() => {
    if (cotacaoStatus === "error") {
      setSalvarDisabled(true);
    }
    if (cotacaoStatus === "success") {
      setSalvarDisabled(false);
    }
    if (cotacaoStatus === "loading") {
      setSalvarDisabled(true);
    }
  }, [cotacaoStatus]);

  useEffect(() => {
    if (numeroCotacao) {
      cotacaoRefetch();
    }
  }, [numeroCotacao]);

  useEffect(() => {
    setDataViasList(dataViasPV);
  }, []);

  const mutateVias = useFiltrarViasPV({
    numeroCotacao,
    tipoDocumento: dataVias,
  });

  useEffect(() => {
    const dataAtual = format(new Date(), "dd-MM-yyyy_HH-mm-ss", {
      locale: ptBR,
    });
    if (mutateVias.isSuccess) {
      setDocumento({
        tipoExtensao: mutateVias?.data?.data?.documento?.tipoExtensao,
        base64: mutateVias?.data?.data?.documento?.base64,
        nome: `documento_${dataAtual}`,
      });
    }
  }, [mutateVias.isSuccess]);

  useEffect(() => {
    setDocumento(null);
  }, [dataVias]);

  const handleGenerate = () => {
    setDocumento(null);
    mutateVias.mutate();
  };

  const handleVincular = () => {
    mutateVincular();
  };

  const handleClose = () => {
    props.refetch();
    props.onClose();
  };

  useEffect(() => {
    if (isSuccessVincular) {
      window.location.reload();
    }
  }, [isSuccessVincular]);

  const downloadDocumento = () => {
    if (!documento) {
      console.error("Documento é null");
      return;
    }

    const { base64 } = documento;
    const byteCharacters = atob(base64);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: documento.tipoExtensao });
    const url = URL.createObjectURL(blob);

    // Criar um link temporário e clicar nele para iniciar o download
    const link = document.createElement("a");
    link.href = url;
    link.download = documento.nome; // Nome do arquivo para download
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    // Liberar o URL temporário
    URL.revokeObjectURL(url);
  };

  return (
    <>
      <Styles.Container>
        <Styles.Item style={{ width: "70%" }}>
          <Styles.Label>Produto</Styles.Label>
          <Styles.StyledTextField
            disabled
            size="small"
            value={props?.headerData?.produto?.label}
          />
        </Styles.Item>
        <Styles.Item style={{ width: "50%" }}>
          <Styles.Label>Bloco</Styles.Label>
          <Styles.StyledTextField
            disabled
            size="small"
            value={props?.headerData?.bloco?.label}
          />
        </Styles.Item>
        <Styles.Item style={{ width: "50%" }}>
          <Styles.Label>Unidade</Styles.Label>
          <Styles.StyledTextField
            disabled
            size="small"
            value={props?.unidadeDataReal?.nomeUnidade}
          />
        </Styles.Item>
      </Styles.Container>
      <Styles.Container style={{ margin: "20px 0" }}>
        <Styles.Row />
        <Styles.Label style={{ whiteSpace: "nowrap" }}>
          Vincular cotação
        </Styles.Label>
        <Styles.Row />
      </Styles.Container>
      <Styles.Container style={{ margin: "0 0 20px 0" }}>
        <Styles.Item>
          <CustomInput
            style={{ borderRadius: "12px" }}
            label="ID da proposta"
            status={cotacaoStatus}
            value={numeroCotacao}
            onChange={(e: string) => setNumeroCotacao(e)}
          />
          {/* <Styles.Label style={{ marginTop: "0" }}>ID da proposta</Styles.Label>
          <Styles.StyledTextField
            size="small"
            onChange={(e) => setNumeroCotacao(e.target.value)}
            value={numeroCotacao}
          /> */}
        </Styles.Item>
      </Styles.Container>
      <Styles.Container style={{ margin: "0 0 20px 0" }}>
        <Styles.Row />
        <Styles.Label style={{ whiteSpace: "nowrap" }}>Proposta</Styles.Label>
        <Styles.Row />
      </Styles.Container>
      <Styles.Container style={{ margin: "0 0 20px 0" }}>
        <Styles.Item>
          <Styles.Label style={{ marginTop: "0" }}>
            Filtrar vias do PV
          </Styles.Label>
          <Styles.StyledSelect
            value={dataVias}
            size="small"
            onChange={(e) => setDataVias(e.target.value as string)}
          >
            {dataViasList.map((item) => (
              <MenuItem
                key={item.value}
                value={item.value}
                sx={{ fontSize: "14px" }}
              >
                {item.label}
              </MenuItem>
            ))}
          </Styles.StyledSelect>
        </Styles.Item>
      </Styles.Container>
      <Styles.Container style={{ margin: "0 0 20px 0" }}>
        <Styles.Button onClick={() => handleGenerate()}>
          {mutateVias?.isLoading ? (
            <MaterialUI.CircularProgress
              size={22}
              style={{ color: "#2d5bff" }}
            />
          ) : (
            <Styles.LightTextBlue style={{ gap: "5px" }}>
              <IoDocumentAttach size={15} />
              Gerar
            </Styles.LightTextBlue>
          )}
        </Styles.Button>
      </Styles.Container>
      {documento !== null ? (
        <Styles.Container style={{ margin: "0 0 20px 0" }}>
          <Styles.Button onClick={() => downloadDocumento()}>
            <Styles.LightTextBlue style={{ gap: "5px" }}>
              <IoDocumentAttach size={15} />
              Baixar via
            </Styles.LightTextBlue>
          </Styles.Button>
        </Styles.Container>
      ) : null}

      <Styles.Row />
      <Styles.SecondContainer>
        <Styles.Button onClick={() => handleClose()}>
          <Styles.LightTextBlue>Editar</Styles.LightTextBlue>
        </Styles.Button>
        <Styles.ButtonBlue
          disabled={salvarDisabled}
          style={{ opacity: salvarDisabled ? 0.7 : 1 }}
          onClick={() => handleVincular()}
        >
          {isLoading ? (
            <MaterialUI.CircularProgress size={22} style={{ color: "#fff" }} />
          ) : (
            <Styles.LightText>Concluir</Styles.LightText>
          )}
        </Styles.ButtonBlue>
      </Styles.SecondContainer>
    </>
  );
};

export default Footer;
